export default __webpack_public_path__ + "static/media/map.f3c6179e.svg";